import '../assets/NcAppNavigationSpacer-C5p-33VT.css';
import { n as e } from "../chunks/_plugin-vue2_normalizer-Bj5bLKV4.mjs";
const r = {
  name: "NcAppNavigationSpacer"
};
var t = function() {
  var a = this, n = a._self._c;
  return n("li", { staticClass: "app-navigation-spacer" });
}, c = [], s = /* @__PURE__ */ e(
  r,
  t,
  c,
  !1,
  null,
  "3dd6c4f7",
  null,
  null
);
const p = s.exports;
export {
  p as default
};
